import script from "./RegisterServiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterServiceModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/admin.css?vue&type=style&index=0&id=ee561acc&scoped=true&lang=css&external"
import "./RegisterServiceModal.vue?vue&type=style&index=1&id=ee561acc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee561acc"]])

export default __exports__